import React, { useState } from 'react';
import {
  Container,
  Paper,
  Typography,
  TextField,
  Button,
  Box,
  CircularProgress
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as api from '../../services/api';

const EmailVerification: React.FC = () => {
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [resending, setResending] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const email = new URLSearchParams(location.search).get('email');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) {
      toast.error('Email không hợp lệ');
      return;
    }

    try {
      setLoading(true);
      const response = await api.verifyEmail({ email, code });
      toast.success(response.message);
      navigate('/login');
    } catch (error: any) {
      toast.error(error.response?.data?.error || 'Xác thực thất bại');
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    if (!email) {
      toast.error('Email không hợp lệ');
      return;
    }

    try {
      setResending(true);
      const response = await api.resendVerification(email);
      if (response.emailSent) {
        toast.success('Đã gửi lại email xác thực');
      } else {
        toast.warning('Không thể gửi email. Vui lòng liên hệ admin.');
      }
    } catch (error: any) {
      toast.error(error.response?.data?.error || 'Không thể gửi lại email');
    } finally {
      setResending(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h5" align="center" gutterBottom>
          Xác thực email
        </Typography>
        <Typography variant="body1" align="center" color="textSecondary" paragraph>
          Vui lòng nhập mã xác thực 6 chữ số đã được gửi đến email của bạn
        </Typography>
        {email && (
          <Typography variant="body2" align="center" color="textSecondary" sx={{ mb: 2 }}>
            Email: {email}
          </Typography>
        )}
        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Mã xác thực"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            margin="normal"
            inputProps={{ maxLength: 6 }}
            required
          />
          <Box sx={{ mt: 3 }}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              type="submit"
              disabled={loading || code.length !== 6}
            >
              {loading ? <CircularProgress size={24} /> : 'Xác thực'}
            </Button>
          </Box>
          <Box sx={{ mt: 2, textAlign: 'center' }}>
            <Button
              variant="text"
              color="primary"
              onClick={handleResend}
              disabled={resending || !email}
              size="small"
            >
              {resending ? <CircularProgress size={20} /> : 'Gửi lại mã xác thực'}
            </Button>
          </Box>
        </form>
      </Paper>
    </Container>
  );
};

export default EmailVerification; 